'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var cartErrorComponent = exports.cartErrorComponent = {
    template: require('./cart-error.html')
};


//////////////////
// WEBPACK FOOTER
// ./features/checkout/cart-error.js
// module id = 903
// module chunks = 0